module.exports = __webpack_public_path__ + "static/media/dashboard-active.98f875a1.svg";